import { useState } from 'react';
import queryString from 'query-string';
import moment from 'moment-timezone';
import { PayloadStates } from '@lore/utils';
import useStewardshipFilter from '@/pages/projects/useStewardshipFilter';

import { useConnect } from '@hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10 } = props;

  const [_timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('project.find', {
    where: {
      eager: {
        $where: {
          // $and: REQUIRED_FIELDS_PUBLIC.$and,
          cancelled: false,
          completed: false,
          activityId: {
            $null: false
          },
          grant: 'Yes',
          $or: stewardshipFilter
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    },
    exclude: function (model) {
      return model.state === PayloadStates.DELETED;
    }
  }, {
    keepPreviousData: true
  });
}